import { inject, Injectable } from '@angular/core';
import { isNil, size } from '@sama/micro-dash';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { selectionToArray } from '../../../../../cross-team-shared/misc-utils';
import { Selection } from '../../../../h3ml/state/fusion-state';
import { TaskWorkspaceStore } from '../../../../h3ml/state/task-workspace-store';

@Injectable()
export class FocusedObjectService {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  getFocusedObjectStore$() {
    return this.taskWorkspaceStore('objectSelection').$.pipe(
      map((selection) => this.getFocusedObjectStoreFromSelection(selection)),
      distinctUntilChanged((prev, curr) => {
        if (isNil(prev) && isNil(curr)) {
          return true;
        }
        if (isNil(prev) || isNil(curr)) {
          return false;
        }
        return prev.refersToSameStateAs(curr);
      }),
    );
  }

  getFocusedObjectStore() {
    return this.getFocusedObjectStoreFromSelection(
      this.taskWorkspaceStore.state().objectSelection,
    );
  }

  private getFocusedObjectStoreFromSelection(selection: Selection) {
    if (size(selection) !== 1) {
      return undefined;
    }
    const objectId = selectionToArray(selection)[0];
    return this.taskWorkspaceStore.getObjectStore(objectId);
  }
}
